import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import VUE from 'vue';
import Vuex from 'vuex';
VUE.use(Vuex);
import { HttpClient } from "@services/http";
import { defaultBuyNum } from '@/utils';
import { AccountStorage } from "@services/account";
var accountStorage = new AccountStorage();
var getHttpClient = function getHttpClient() {
  var options = {};
  var requestOptions = {};
  requestOptions.timeout || (requestOptions.timeout = 30000);
  requestOptions.headers || (requestOptions.headers = {});
  requestOptions.headers = Object.assign({
    AccessToken: accountStorage.getCacheAccessToken() || "",
    'X-AURORA-TOKEN': 'Vuc2gPv0kxqagTZD'
  }, requestOptions.headers);
  return new HttpClient(options, requestOptions);
};
export default new Vuex.Store({
  state: {
    //这里放全局参数
    tablist: [],
    cardInfo: {},
    //购物车
    categorylist: [],
    // 产品分类
    formulationList: [],
    //剂型列表
    actBal: {},
    //活动次数，账户金额
    iframeLogin: false,
    showJiedanTip: true,
    //是否显示截单提示
    isAddCard: false,
    //是否添加购物车，主要做动画效果
    isShowVideoEntrance: false,
    //是否显示视频红包入口
    Redbag2: null,
    isShowLeftRedbag: true,
    videoRedEnvelopeData: JSON.parse(localStorage.getItem('videoRedEnvelopeData')) || {} // 视频红包数据
  },
  mutations: {
    resetState: function resetState(state) {
      state.tablist = [];
      state.cardInfo = {};
      state.categorylist = [];
      state.formulationList = [];
      state.actBal = {};
      state.iframeLogin = false;
      state.isAddCard = false;
      state.showJiedanTip = true;
      state.isShowVideoEntrance = false;
      state.isShowLeftRedbag = true;
      state.videoRedEnvelopeData = JSON.parse(localStorage.getItem('videoRedEnvelopeData')) || {};
    },
    //这里是set方法
    settablist: function settablist(state, arr) {
      state.tablist = arr;
    },
    setIframeLogin: function setIframeLogin(state, status) {
      console.log('setIframeLogin', status);
      state.iframeLogin = status;
    },
    setCardInfo: function setCardInfo(state, cardInfo) {
      state.cardInfo = cardInfo;
    },
    setRedbag2: function setRedbag2(state, Redbag2) {
      state.Redbag2 = Redbag2;
    },
    setCategorylist: function setCategorylist(state, lst) {
      state.categorylist = lst;
    },
    setFormulationlist: function setFormulationlist(state, lst) {
      state.formulationList = lst;
    },
    setActBal: function setActBal(state, obj) {
      state.actBal = obj;
    },
    setshowJiedanTip: function setshowJiedanTip(state, flag) {
      state.showJiedanTip = flag;
    },
    setIsAddCard: function setIsAddCard(state, flag) {
      state.isAddCard = flag;
    },
    setIsShowVideoEntrance: function setIsShowVideoEntrance(state, flag) {
      state.isShowVideoEntrance = flag;
    },
    setIsShowLeftRedbag: function setIsShowLeftRedbag(state, flag) {
      state.isShowLeftRedbag = flag;
    },
    setVideoRedEnvelopeData: function setVideoRedEnvelopeData(state, data) {
      localStorage.setItem('videoRedEnvelopeData', JSON.stringify(data));
      state.videoRedEnvelopeData = data;
    }
  },
  getters: {
    //这里是get方法
    iframeLogin: function iframeLogin(state) {
      return state.iframeLogin;
    },
    cardInfo: function cardInfo(state) {
      return state.cardInfo;
    },
    Redbag2: function Redbag2(state) {
      return state.Redbag2;
    },
    categoryList: function categoryList(state) {
      return state.categorylist;
    },
    formulationList: function formulationList(state) {
      return state.formulationList;
    },
    actBal: function actBal(state) {
      return state.actBal;
    },
    showJiedanTip: function showJiedanTip(state) {
      return state.showJiedanTip;
    },
    isAddCard: function isAddCard(state) {
      return state.isAddCard;
    },
    isShowVideoEntrance: function isShowVideoEntrance(state) {
      return state.isShowVideoEntrance;
    },
    isShowLeftRedbag: function isShowLeftRedbag(state) {
      return state.isShowLeftRedbag;
    },
    videoRedEnvelopeData: function videoRedEnvelopeData(state) {
      return state.videoRedEnvelopeData;
    }
  },
  actions: {
    //视频红包入口是否显示
    getIsShowVideoEntrance: function getIsShowVideoEntrance(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, url, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              url = '/pjyy-deepexi-market-center/api/v1/up/mobile/video/getOnlineVideocount';
              _context.next = 4;
              return getHttpClient().get(url, {
                "headers": {
                  "TokenType": 'customer'
                }
              });
            case 4:
              res = _context.sent;
              if (res.data.code == '200') {
                if (res.data.data != 0) {
                  commit('setIsShowVideoEntrance', true);
                }
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    setIsAddCard: function setIsAddCard(_ref2, flag) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var commit;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              commit('setIsAddCard', flag);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    resetState: function resetState(_ref3) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var commit;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              commit('resetState');
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    setshowJiedanTip: function setshowJiedanTip(_ref4, flag) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var commit;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit;
              commit('setshowJiedanTip', flag);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    /**
     * 拉取购物车数据
     * @param {*} param0
     */
    findCardList: function findCardList(_ref5) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var commit, url, result, obj, c;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref5.commit;
              url = '/pjyy-deepexi-order-center/api/v1/cart/findCartList';
              _context5.next = 4;
              return getHttpClient().post(url, {
                "productId": [],
                "totalNumber": null,
                "isChecked": 1,
                "code": 0
              }, {
                useSpinner: false
              });
            case 4:
              result = _context5.sent;
              obj = {};
              if (result.data.code == 200) {
                obj = result.data.data;
                if (obj.ocCartLists != null && obj.ocCartLists.length > 0) {
                  c = 0;
                  obj.ocCartLists = defaultBuyNum(obj.ocCartLists);
                  obj.ocCartLists.forEach(function (t) {
                    if (t.isChecked) {
                      c = c + 1;
                    }
                  });
                  obj.num = c;
                }
              }
              commit('setCardInfo', obj);
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    //获取侧边栏红包数据
    getRedPacketData: function getRedPacketData(_ref6) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var commit, url, res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref6.commit;
              url = '/pjyy-deepexi-user-center/api/v1/balance/pageList';
              _context6.next = 4;
              return getHttpClient().post(url, {
                page: 1,
                size: 20
              });
            case 4:
              res = _context6.sent;
              if (res.data.code == 200) {
                commit("setRedbag2", res.data.data.totalBalanceAmount);
              }
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    /**
     * 更新购物车，购物车操作时候会直接返回列表
     * @param {*} param0
     * @param {*} obj
     */
    updateCard: function updateCard(_ref7, obj) {
      var commit = _ref7.commit;
      if (obj.ocCartLists != null && obj.ocCartLists.length > 0) {
        var c = 0;
        obj.ocCartLists = defaultBuyNum(obj.ocCartLists);
        obj.ocCartLists.forEach(function (t) {
          if (t.isChecked) {
            c = c + 1;
          }
        });
        obj.num = c;
      }
      commit('setCardInfo', obj);
    },
    getCategoryLst: function getCategoryLst(_ref8) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var commit, URL, result, dataSource;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref8.commit;
              URL = "/pjyy-deepexi-product-center/api/v1/background/PcCatalog/pageList";
              _context7.next = 4;
              return getHttpClient().post(URL);
            case 4:
              result = _context7.sent;
              if (result && result.data.code === "200") {
                dataSource = result.data.data;
                commit('setCategorylist', dataSource);
              }
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getFormulationLst: function getFormulationLst(_ref9) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var commit, URL, result, dataSource;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              commit = _ref9.commit;
              URL = "/pjyy-deepexi-product-center/api/v1/product/PcProduct/searchConditions";
              _context8.next = 4;
              return getHttpClient().get(URL);
            case 4:
              result = _context8.sent;
              if (result && result.data.code === "200") {
                dataSource = result.data.data.formulationConditions;
                commit('setFormulationlist', dataSource);
              }
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    //活动次数，账户金额
    getActBal: function getActBal(_ref10) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var commit, URL, result, dataSource;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              commit = _ref10.commit;
              URL = "/pjyy-deepexi-user-center/api/v1/balance/getMonthStatistics";
              _context9.next = 4;
              return getHttpClient().get(URL);
            case 4:
              result = _context9.sent;
              if (result && result.data.code === "200") {
                dataSource = result.data.data;
                commit('setActBal', dataSource);
              }
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    //这个部分我暂时用不上
    gettablist: function gettablist(_ref11) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var commit, URL, result, arr;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              commit = _ref11.commit;
              URL = "/pjyy-deepexi-product-center/api/v1/product/PcProductConfigure/selectConfigureList?key=" + 'APP_PRODUCT_LABE';
              _context10.next = 4;
              return getHttpClient().get(URL);
            case 4:
              result = _context10.sent;
              arr = [];
              if (result.data.code == 200) {
                arr = result.data.data;
                arr.map(function (item) {
                  if (item.tabnav == 1 || item.tabnav == 2) {
                    item.children.map(function (item1) {
                      item1.datalist = [];
                      item1.pagenum = 0;
                      item = item1;
                    });
                  }
                  if (item.tabnav == 3) {
                    item.pagenum = 0;
                    item.datalist = [];
                  }
                });
              }
              commit('settablist', arr);
            case 8:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    // 获取红包数据type1学术视频 2视频红包
    getRedBagData: function getRedBagData(_ref12) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var commit, URL, res;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              commit = _ref12.commit;
              URL = "/pjyy-deepexi-product-center/api/v3/product/PcProduct/countVideoInfo";
              _context11.next = 4;
              return getHttpClient().post(URL, {
                type: 1
              });
            case 4:
              res = _context11.sent;
              if (res.data.code == 200) {
                commit('setVideoRedEnvelopeData', res.data.data);
              }
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    setIsShowLeftRedbag: function setIsShowLeftRedbag(_ref13, flag) {
      var commit = _ref13.commit;
      commit('setIsShowLeftRedbag', flag);
    }
  }
});